var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFindSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 62,
    viewBox: "0 0 63 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0833 51.6667V46.5C34.0833 39.3664 28.3003 33.5834 21.1667 33.5834C14.033 33.5834 8.25 39.3664 8.25 46.5V51.6667H34.0833ZM34.0833 51.6667H54.75V49.0834C54.75 41.4741 48.967 36.1667 41.8333 36.1667C38.1822 36.1667 34.885 37.7826 32.5357 40.3804M28.9167 18.0834C28.9167 22.3636 25.4469 25.8334 21.1667 25.8334C16.8865 25.8334 13.4167 22.3636 13.4167 18.0834C13.4167 13.8032 16.8865 10.3334 21.1667 10.3334C25.4469 10.3334 28.9167 13.8032 28.9167 18.0834ZM47 23.25C47 26.1035 44.6868 28.4167 41.8333 28.4167C38.9799 28.4167 36.6667 26.1035 36.6667 23.25C36.6667 20.3966 38.9799 18.0834 41.8333 18.0834C44.6868 18.0834 47 20.3966 47 23.25Z",
    stroke: "url(#paint0_linear_7321_20002)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7321_20002",
    x1: 8.25,
    y1: 31,
    x2: 54.75,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#992FDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D73FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindSupport);
export default __webpack_public_path__ + "static/media/findSupport.7c2f0d54191fd70ebb796ff9fc6d01dd.svg";
export { ForwardRef as ReactComponent };